import '../component/Sidebar/Sidebar.css'

export const RouteInfo = {
    Root: {
        url: "",
        globalUrl: "/panel/",
        name: "داشبورد",
        icon: 'residence-icon',
    },
    Dashboard: {
        url: "dashboard",
        globalUrl: "/panel/dashboard",
        name: "داشبورد",
        icon: 'dashboard-icon',
    },
    Profile: {
        url: "profile",
        globalUrl: "/panel/profile",
        name: "حساب کاربری",
        icon: 'profile',
    },
    union: {
        url: "union",
        globalUrl: "/panel/union",
        name: "اتحادیه",
        icon: 'profile',
    },
    generalAdmin: {
        url: "general-admin",
        globalUrl: "/panel/general-admin",
        name: "مدیر کل",
        icon: 'profile',
    },
    CashInfo: {
        url: "cash-info",
        globalUrl: "/panel/cash-info",
        name: "صندوق",
        icon: 'cash-icon',
    },
    Group: {
        url: "group",
        globalUrl: "/panel/group",
        name: "گروه ها",
        icon: 'cash-groups-icon',
    },
    CashGroups: {
        url: "group/cash-groups",
        globalUrl: "/panel/group/cash-groups",
        name: "گروه ها",
        icon: 'cash-groups-icon',
    }
    , CashGroupsReport: {
        url: "group/cash-groups-report",
        globalUrl: "/panel/group/cash-groups-report",
        name: "گزارش",
        icon: 'cash-groups-icon',
    },
    CashUsers: {
        url: "cash-users",
        globalUrl: "/panel/cash-users",
        name: "اعضا",
        icon: 'cash-users-icon',
    },
    Loin: {
        url: "loin",
        globalUrl: "/panel/loin",
        name: "وام",
        icon: 'loins-icon',
    },
    LoinList: {
        url: "loin/list",
        globalUrl: "/panel/loin/list",
        name: "وام ها",
        icon: 'loins-icon',
    },
    LoinRequest: {
        url: "loin/request",
        globalUrl: "/panel/loin/request",
        name: "درخواست ها",
        icon: 'loins-icon',
    },
    CashTransactions: {
        url: "cash-transactions",
        globalUrl: "/panel/cash-transactions",
        name: "دخل و خرج",
        icon: 'transactions-icon',
    },
    CashTransactionsList: {
        url: "cash-transactions/list",
        globalUrl: "/panel/cash-transactions/list",
        name: "تراکنشات",
        icon: 'transactions-icon',
    },
    TagsManager: {
        url: "cash-transactions/tag-manager",
        globalUrl: "/panel/cash-transactions/tag-manager",
        name: "تگ ها",
        icon: 'tags-icon',
    },
    CostCategoryManager: {
        url: "cash-transactions/category-manager",
        globalUrl: "/panel/cash-transactions/category-manager",
        name: "دسته بندی",
        icon: 'tags-icon',
    },
    Feedback: {
        url: "feedback",
        globalUrl: "/panel/feedback",
        name: "انتقادات",
        icon: 'feedbacks-icon',
    },

    FirstItem: {
        url: "first-item",
        globalUrl: "/panel/first-item",
        name: "آیتم اول",
        icon: 'residence-icon',
    },
    FirstItemFirstChild: {
        url: "first-item/first-child",
        globalUrl: "/panel/first-item/first-child",
        name: "فرزند اول",
        icon: 'residence-icon',
    },
    FirstItemSecondChild: {
        url: "first-item/second-child",
        globalUrl: "/panel/first-item/second-child",
        name: "فرزند دوم",
        icon: 'residence-icon',
    },
    SecondItem: {
        url: "second-item",
        globalUrl: "/panel/second-item",
        name: "نمونه جدول",
        icon: 'residence-icon',
    },
    Login: {
        url: "panel/login",
        globalUrl: "/panel/login",
        name: "ورود",
        icon: '',
    },
    ForgetPassword: {
        url: "panel/forget-password",
        globalUrl: "/panel/forget-password",
        name: "فراموشی رمز عبور",
        icon: '',
    },
    ConfirmPhoneNumber: {
        url: "panel/confirm-phone-number",
        globalUrl: "/panel/confirm-phone-number",
        name: "تایید شماره تماس",
        icon: '',
    },
    PasswordRecovery: {
        url: "panel/password-recovery",
        globalUrl: "/panel/password-recovery",
        name: "بازیابی رمز عبور",
        icon: '',
    },
    Account: {
        url: "account",
        globalUrl: "/panel/account",
        name: "حساب",
        icon: "cash_account-icon"
    },
    ListOfAccounts: {
        url: "account/list-of-accounts",
        globalUrl: "/panel/account/list-of-accounts",
        name: "حساب ها",
        icon: '',
    },
    Transactions: {
        url: "account/transactions",
        globalUrl: "/panel/account/transactions",
        name: "تراکنشات",
        icon: '',
    },
    SavingsDepositTransactions: {
        url: "account/SavingsDepositTransactions",
        globalUrl: "/panel/account/SavingsDepositTransactions",
        name: "تراکنشات واریز پس انداز",
        icon: '',
    },
    Checkout: {
        url: "account/Checkout",
        globalUrl: "/panel/account/Checkout",
        name: "تسویه حساب",
        icon: '',
    },
    NotFound: {
        url: "notfound",
        globalUrl: "/panel/notfound",
        name: "notfound",
        icon: '',
    },
    Installments: {
        url: "installments-list",
        globalUrl: "/panel/installments-list",
        name: "اقساط",
        icon: 'loins-icon',
    },
    Election: {
        url: "election",
        globalUrl: "/panel/election",
        name: "انتخابات",
        icon: 'election-icon',
    },
    OtherPayments: {
        url: "other-payments",
        globalUrl: "/panel/other-payments",
        name: "سایر پرداخت ها",
        icon: 'loins-icon',
    },
    PaymentTransaction: {
        url: "payment-transaction",
        globalUrl: "/panel/payment-transaction",
        name: "تراکنشات بانکی",
        icon: 'bank-icon',
    }
}

